import HttpInterceptor from './HttpInterceptor';

export default class DefaultHttpInterceptor
    extends HttpInterceptor {
  transform(options) {
    return options;
  }
}
